import { render, staticRenderFns } from "./featured-icon.vue?vue&type=template&id=5dff1a46"
import script from "./featured-icon.vue?vue&type=script&lang=js"
export * from "./featured-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports